import { TournamentTrick } from '../../../types';

type Kwc2026Entry = [english: string, japanese: string, chinese: string];

const createLevelTricks = (level: number, entries: Kwc2026Entry[]): TournamentTrick[] =>
  entries.map(([english, japanese, chinese], index) => ({
    id: `kwc2026-${level}-${index + 1}`,
    name: `${level}-${index + 1} ${english}\n${japanese}\n${chinese}`,
    score: level
  }));

const KWC2026_LEVEL_1: Kwc2026Entry[] = [
  ['Wave (Big Cup)', '波（大皿）', '波（大皿）'],
  ['Scooping Airplane', 'どじょうすくい', '泥鳅捞（捞剑）'],
  ['Lazy Lighthouse', 'けん玉つみき灯台', '懒人灯台'],
  ['Tama Drop Base Cup Catch', '中皿おとし玉', '玉落中皿接'],
  ['Hula Hoop (Big Cup)', 'フラフープ（大皿）', '呼啦圈（大皿）'],
  ['Hanging, Two Hand Catch', 'つるし～両手キャッチ', '悬挂双手接'],
  ['Easy Big Cup, Walk 5 Steps', '手のせ大皿ウォーク5歩', '手托大皿走5步'],
  ['Easy Big Cup, Squat', '手のせ大皿スクワット', '手托大皿深蹲'],
  ['Easy Big Cup', '手のせ大皿', '手托大皿'],
  ['Easy Big Cup, Hop', '手のせ大皿ホップ', '手托大皿跳跃']
];

const KWC2026_LEVEL_2: Kwc2026Entry[] = [
  ['Candlestick', 'ろうそく', '烛台'],
  ['Big Cup', '大皿', '大皿'],
  ['Small Cup -> Big Cup -> Base Cup', '小皿～大皿～中皿', '小皿 -> 大皿 -> 中皿'],
  ['Easy Big Cup, Hopscotch', '手のせ大皿～けんけんぱ', '手托大皿→单脚跳'],
  ['Baseball', '野球', '棒球'],
  ['Takoyaki', 'たこやき', '章鱼烧'],
  ['Easy Big Cup -> Spike', '手のせ大皿～けん', '手托大皿 -> 顶剑'],
  ['Moshikame x11', 'もしかめ11回', '皿上来回x11'],
  ['Hanging Clap Catch', '手拍子つるし持ち', '悬挂拍手接'],
  ['Pull Up Spike (Spin or No Spin)', 'とめけん（まわしけん可）', '直拉止剑（可旋转）']
];

const KWC2026_LEVEL_3: Kwc2026Entry[] = [
  ['Tama Grip, Throw to Big Cup', 'ず～まスロー大皿', '小钟摆'],
  ['Airplane', '飛行機', '飞机'],
  ['Around Japan', '日本一周', '日本一周'],
  ['Around the World', '世界一周', '世界一周'],
  ['Moshikame x10 or More, Spike', 'もしかめ10回以上 → けん', '皿上来回10次以上 -> 止剑'],
  ['Lighthouse, In', '灯台～さかおとし', '灯台 -> 持球收'],
  ['Stuntplane', 'すくいけん', '玉中杀'],
  ['Swing Spike', 'ふりけん', '游泳'],
  ['Pull Up Spike (Spin or No Spin), Flying Top', 'とめけん（まわしけん可）～たけとんぼ', '直拉止剑（可旋转球）-> 竹蜻蜓'],
  ['Downspike', 'ダウンスパイク', '天中杀']
];

const KWC2026_LEVEL_4: Kwc2026Entry[] = [
  ['Spike, Flying Top -> Bungee Kenflip Spike', 'とめけん～たけとんぼバンジーけんフリップけん', '止剑 -> 竹蜻蜓蹦极离转止剑'],
  ['Jumping Stick', 'はねけん', '跳剑'],
  ['Around Europe', 'ヨーロッパ一周', '欧洲一周'],
  ['Stuntplane Fast Hand', 'すくいけんファストハンド', '玉中杀快手'],
  ['Base Cup -> Airplane In', '中皿～さかおとし', '中皿 -> 一回转持球收'],
  ['1 Turn Lighthouse -> Tradespike', '1回転灯台～けん', '一回转灯台 -> 持剑止'],
  ['Bird -> Flip Spike', 'うぐいす～回転けん', '鸟 -> 地球止剑'],
  ['Lunar, Flip in', '月面着陸～１回転さかおとし', '月面->一回转持球收'],
  ['Flamingo Takoyaki on Foot', 'フラミンゴ足たこやき', '弗朗明哥章鱼烧（抬单脚球放脚上做章鱼烧）'],
  ['Airplane -> Base Cup -> Downspike', 'レジェンド', '飞机 -> 中皿 -> 天中杀']
];

const KWC2026_LEVEL_5: Kwc2026Entry[] = [
  ['Whirlpool Spike', 'うずしおふりけん', '漩涡回旋剑（糖果特技）'],
  ['Jumping Stick, Inward Jumping Stick', 'はねけん～うらはねけん', '跳剑 -> 反跳剑'],
  ['Around USA', 'USA一周', '美国一周'],
  ['Whirlwind', 'ワールウィンド', '离转地球'],
  ['Juggle Big Cup, Spike', 'ジャグル大皿～けん', '小丑大皿 -> 止剑'],
  ['Stilt, Flip In', 'たけうま～1回転さかおとし', '竹马 -> 一回转收'],
  ['Handlestall, 1 Turn Spike', '中皿極意～回転けん', '中皿极意 -> 地球止'],
  ['Inward Lunar, Lunar, Lighthouse, In', 'うら月面～月面～灯台～さかおとし', '逆月面 -> 月面 -> 灯台 -> 持球收'],
  ['Tap Flip In', 'タップ1回転イン', 'Tap一回收'],
  ['Spacewalk', '宇宙遊泳', '宇宙游泳']
];

const KWC2026_LEVEL_6: Kwc2026Entry[] = [
  ['Juggle Spike', 'ジャグルとめけん', '小丑止剑'],
  ['Airplane, 1.5 Swap Spike', '飛行機～1.5回転スワップけん', '飞机 -> 1.5止剑'],
  ['Inward 1 Turn Lighthouse, Inward Lighthouse Flip, Inward Flip In', 'うら1回転灯台～うら灯台とんぼ返り～うら1回転さかおとし', '反一回转灯台 -> 反灯台一回 -> 反一回收'],
  ['Double Whirlwind', 'ダブルワールウィンド', '2回转离转地球'],
  ['Double Gunslinger Spike', '2回転風車けん', '2回转神枪手止剑'],
  ['Stilt Flip, Flip In', 'たけうまとんぼ返り～1回転さかおとし', '竹马 -> 竹马一回 -> 一回转收'],
  ['2 Turn Airplane, Double Jumping Stick', '2回転飛行機～2回転はねけん', '2回转飞机 -> 2跳剑'],
  ['Inward Lunar, Flip Cushion Tap, Inward Lunar In', 'うら月面～1回転クッションタップ～うら月面', '逆月面 -> 一回转Cushion Tap逆月面 -> 一回转收'],
  ['Foot Spike', '足けん', '脚止剑'],
  ['Lightning Drop Swap Spike', '稲妻おとしスワップけん', '闪电下落止剑']
];

const KWC2026_LEVEL_7: Kwc2026Entry[] = [
  ['Tap Juggle Spike', 'タップジャグルけん', 'Tap小丑止剑'],
  ['Airplane, 1.5 Swap Juggle Spike', '飛行機～1.5回転スワップジャグルけん', '飞机 -> 1.5小丑止剑'],
  ['Around Stall, 1 Turn Spike', 'ふち一周～回転けん', '极易一周 -> 地球止'],
  ['Bird, Kenflip Bird, 1 Turn Spike', 'うぐいす～けんフリップ～うぐいす～回転けん', '大鸟 -> 离转大鸟 -> 地球止'],
  ['1 Turn Lighthouse, Tap Lighthouse, Reverse Tap Lighthouse, Tradespike', '1回転灯台～タップ灯台往復～タップ灯台～けん', '一回转灯台 -> Tap灯台 -> 反Tap灯台 -> 持剑止'],
  ['Kengrip Underbird, Pressure Underbird, Candle Grip Underbird, Swap In', 'アンダーバード～遠心力アンダーバード～ろうそくアンダーバード～さかおとし', '安德鸟重力机 -> 烛台握法安德鸟 -> 持球收'],
  ['Wing over the Valley, 1 Turn Spike', 'ウィング渡り～回転けん', '大皿极易渡 -> 一回转止剑'],
  ['Around Downspike Fasthand', 'ダウンスパイクファストハンド一周', '天中杀快手一周'],
  ['Moshikame x100 or More, Spike', 'もしかめ100回以上～けん', '皿上来回100次或以上 -> 止剑'],
  ['1 Turn Lighthouse, Swap Toss Lighthouse, Stuntplane Fasthand', '1回転灯台～スワップ投げ灯台～すくいけんファストハンド', '一回转灯台 -> 换手抛灯台 -> 玉中杀快手']
];

const KWC2026_LEVEL_8: Kwc2026Entry[] = [
  ['2 Tap Juggle Spike', '2タップジャグルけん', '2Tap小丑止剑'],
  ['Airplane, 1.5 Swap Juggle Bird, 1 Turn Spike', '飛行機～1.5回転スワップジャグルうぐいす～回転けん', '飞机 -> 1.5小丑大鸟 -> 地球止'],
  ['1-2-3 Lighthouse Flip, Tradespike', '灯台とんぼ返り1-2-3～けん', '灯台1-2-3 -> 持剑止'],
  ['Kenflip Juggle Kenflip Juggle Spike', 'マテオチャンス', '离转小丑 -> 离转小丑止剑'],
  ['Juggle Spike, 2 Juggle Spike, 3 Juggle Spike', 'ジャグルけん～2ジャグルけん～3ジャグルけん', '小丑止剑 -> 2回转小丑止剑 -> 3回转小丑剑'],
  ['3 Gunslinger Bird, 1 Turn Spike', '3回転風車うぐいす～回転けん', '3回转神枪大鸟 -> 地球止'],
  ['Stilt over the Valley, Axe over the Valley, Tradespike', 'たけうま渡り～まさかり渡り～けん', '竹马渡 -> 斧渡 -> 持剑收'],
  ['Handlestall, Earth Turn Handlestall, Inward Earth Turn Handlestall, 1 Turn Spike', '中皿極意、地球まわし中皿極意うら地球まわし中皿極意～回転けん', '中皿极意 -> 中皿极意一回 -> 反中皿极意一回 -> 地球止'],
  ['1 Turn Arm Bounce Swap Toss', '1回転アームバウンストスアームバウンス1回転さかおとし', '一回转手臂Insta抛剑手臂Insta一回转持球收'],
  ['Kenflip Swap Stuntplane Fasthand', 'けんフリップスワップすくいけんファストハンド', '抛剑一回转玉中杀快手']
];

const KWC2026_LEVEL_9: Kwc2026Entry[] = [
  ['10 or More Juggle -> Spike', 'ジャグル10回以上～けん', '小丑10次以上 -> 止剑'],
  ['Airplane, Big Tap x2 -> Swap Juggle Spike', '飛行機～ビッグタップ2～スワップジャグルけん', '飞机 -> 大Tapx2 -> 小丑止剑'],
  ['1-2-3 Whirlwind', 'ワールウィンド1-2-3', '离转地球1-2-3'],
  ['3 Kenflip -> Inward 3 Kenflip Juggle Spike', '3回転けんフリップ～うら3回転けんフリップジャグルけん', '3离转 -> 反3离转小丑止剑'],
  ['Airplane, 1.5 Swap Gunslinger 1.5 Toss In', '飛行機～1.5回転スワップ風車1.5回転トスイン', '飞机 -> 跳剑1.5 神枪手1.5 Toss In'],
  ['Stilt over the Valley, Swap Bird over the Valley, 1 Turn Spike', 'たけうま渡り～うぐいすの谷渡り～回転けん', '竹马渡 -> 鸟渡 -> 地球止'],
  ['Wing over the Valley, Handlestall, 1 Turn Spike', 'ウィング渡り～中皿極意～回転けん', '大皿极易渡小皿极易 -> 中皿极意 -> 地球止'],
  ['Airplane, 3.5 Flip Swap 3.5 Kenflip Juggle Downspike', '飛行機～3.5回転フリップスワップ3.5回転けんフリップジャグルダウンスパイク', '飞机 -> 跳剑3.5 -> 抛3.5 -> 天中杀'],
  ['Floor Spike Tap Spike Hold, Downspike', 'フロアけんタップおこし中皿～ダウンスパイク', '地面剑尖Tap立中皿 -> 天中杀'],
  ['Mooncircle Mooncircle Kenflip-Flip Swing Spike', '胡蝶の舞けんフリップフリップつりけん', '月环月环 -> 离转Late止剑']
];

const KWC2026_LEVEL_10: Kwc2026Entry[] = [
  ['Airplane, Cushion Tap Swap Ghost Toss Tap Flip Swap Toss Cushion Tap In', '飛行機～クッションタップスワップゴーストトスタップ、フリップスワップトスクッションタップイン', '飞机 -> Cushion Tap -> 抛幽灵Tap -> 抛Cushion Tap持球收'],
  ['3 Kenflip -> 3 Kenflip Juggle 3.5 Toss In', '3回転けんフリップ～3回転けんフリップジャグル3.5回転トスイン', '3离转 -> 3离转 -> 小丑3.5 Toss In'],
  ['Spike, Hippie 3 Flip Swap Spike', 'スパイクヒッピー3回転フリップスワップけん', '止剑 -> Hippie三圈持剑收'],
  ['Airplane, 4 Tap Swap 1.5 Toss In', '飛行機～4タップスワップ1.5回転トスイン', '飞机 -> 4Tap -> 抛1.5 Toss In'],
  ['Kenflip to Cloud Bounce Juggle Kenflip Spike', 'けんフリップスワップラウドバウンスジャグルけんフリップけん', '离转云端弹射 -> 小丑离转止剑'],
  ['3 Tap 3 Kenflip Juggle Spike', '3タップ3回転けんフリップジャグルけん', '3Tap -> 3离转小丑止剑'],
  ['Around the Ken, Flip In', 'たけうまこがし～1回転さかおとし', '剑一周 -> 一回转持球收'],
  ['Backward Inward Lunar, 1.5 Backflip Lunar, Backflip Inward Lunar, Flip Swap Spike', '前ふりバックワードうら月面～1.5回転バックフリップ月面～1.5回転バックフリップうら月面～1回転スワップけん', '逆梦月 -> 1.5回转梦月 -> 1.5回转逆梦月 -> 一回转持剑止'],
  ['Flamingo Swing Spike, Flamingo Whirlwind', 'フラミンゴふりけん～フラミンゴワールウィンド', '弗朗明哥游泳 -> 弗朗明哥离转地球（从持剑手腿下通过）'],
  ['Gunslinger Toss Lighthouse, Inward Lighthouse Flip into 3 Flip Swap Gunslinger Spike', '風車トス灯台～うら灯台とんぼ返り3回転フリップスワップ風車けん', '神枪手抛灯台 -> 反灯台Insta3圈 -> 抛神枪手止剑']
];

const KWC2026_LEVEL_11: Kwc2026Entry[] = [
  ['Kenflip -> 2 Kenflip Juggle 3 Kenflip Spike', 'けんフリップ→2回転けんフリップジャグル3回転けんフリップけん', '离转 -> 2离转 -> 3离转止剑'],
  ['Bird, Inward Toss Tap Swap Kenflip Bird, 1 Turn Spike', 'うぐいす～うらタップスワップうぐいすうぐいす～回転けん', '大鸟 -> 反抛Tap -> 离转大鸟 -> 地球止'],
  ['Cushion Tap Swap 2 Toss Cushion Tap Swap 3 Toss Cushion Tap Swap Spike', 'クッションタップスワップ2回転トスクッションタップスワップ3回転トスクッションタップスワップけん', 'Cushion Tap -> 抛2圈Cushion Tap -> 抛3圈Cushion Tap持剑止'],
  ['Kenflip Inward Toss Tap Inward Toss Tap Swap Spike', 'けんフリップうらフリップトススワップうらスワップスパイク', '正反离转 -> 抛Tap -> 反抛Tap持剑止'],
  ['Stilt Flip 1-2-3, Flip In', 'たけうまとんぼ返り1-2-3～1回転さかおとし', '竹马1-2-3 -> 一回转持球收'],
  ['Big Tap x2 -> Juggle Handlestall, Downspike Fasthand', 'ビッグタップ×2～ジャグル中皿極意～ダウンスパイクファストハンド', '大Tapx2 -> 小丑中皿极意 -> 天中杀快手'],
  ['4 Tap Juggle Kenflip Bird, 1 Turn Spike', '4タップジャグルけんフリップうぐいす～回転けん', '4Tap小丑离转大鸟 -> 地球止'],
  ['Pull Up Tap Inward 2 Flip Swap Ghost Toss Tap Inward 2 Flip Inward Lunar, Tap Inward 2 Flip Swap Spike', 'プルアップタップうら2回転スワップゴーストトスタップうら2回転うら月面～タップうら2回転スワップけん', '直拉反Tap -> 抛幽灵反Tap2圈逆月面 -> Tap2圈持剑止'],
  ['Handlestall, Swap Stilt over the Valley, Swap Handlestall, Downspike', '中皿極意～たけうま渡り～～回転けん中皿極意～ダウンスパイク', '中皿极意 -> 竹马渡 -> 中皿极意 -> 天中杀'],
  ['Stuntplane, 3 Flip Stuntplane Penguin Fasthand', 'すくいけん～3回転フリップすくいけんペンギンファストハンド', '玉中杀 -> 3圈玉中杀企鹅快手']
];

const KWC2026_LEVEL_12: Kwc2026Entry[] = [
  ['1.5 Goon Circle 1 Turn Stuntplane Fasthand', '稲妻はやて1回転すくいけんファストハンドド', '1.5圈Goon Circle -> 一回转玉中杀快手'],
  ['6 Tap Swap Toss Lighthouse Insta 3 Flip Swap 3 Kenflip Juggle Spike', '6タップスワップトス灯台インスタ3回転フリップスワップ3回転けんフリップジャグルけん', '6Tap抛灯台Insta三圈 -> 抛三圈离转小丑止剑'],
  ['1-2-3 Lunar Barrel Roll, In', '月面バレルロール1-2-3～さかおとし', '月面桶滚1-2-3 -> 持球收'],
  ['Airplane, 1.5 Swap Kenflip-Flip-Flip 1.5 Toss In', '飛行機～1.5回転スワップけんフリップフリップフリップ1.5回転トスイン', '飞机 -> 1.5回转 -> 离转LateLate -> 1.5回转Toss In'],
  ['Airplane, 3 Tap Swap Inward 2.5 Toss Tap Swap Inward 3.5 Toss In', '飛行機～3タップスワップうら2.5回転トスタップスワップうら3.5回転トスイン', '飞机 -> 3Tap -> 反抛2.5回转Toss Tap -> 反抛3.5回转Toss In'],
  ['1-2-3 Lighthouse Flip Insta Inward Lighthouse Flip, Tradespike', '灯台とんぼ返りインスタうらとんぼ返り1-2-3～けん', '灯台一回反Insta 1-2-3灯台 -> 持剑止'],
  ['Inward Stilt, 4 Inward Stilt Flip, Flip In', 'うらたけうま～4回転うらたけうまとんぼ返り～1回転さかおとし', '反竹马 -> 4回转反竹马 -> 一回转收'],
  ['Airplane, 4 Tap Swap Inward Gunslinger Downspike Fasthand', '飛行機～4タップスワップうら風車ダウンスパイクファストハンド', '飞机 -> 4Tap -> 反神枪手天中杀快手'],
  ['Pirouette Hanging Spike', 'ピルエットつるしけん', '提线转身止剑'],
  ['Around Tunbridge Wells', 'タンブリッジウェルズ一周', 'Tunbridge Wells 一周']
];

const KWC2026_LEVEL_13: Kwc2026Entry[] = [
  ['Kenflip Juggle Kenflip-Flip Juggle Kenflip-Flip-Flip Spike', 'けんフリップジャグルけんフリップフリップジャグルけんフリップフリップフリップけん', '离转小丑 -> 离转Late小丑 -> 离转LateLate止剑'],
  ['Big Tap x4 -> Juggle Ghost Stuntplane Fasthand', 'ビッグタップ×4→ジャグルゴーストすくいけんファストハンド', '大Tapx4 -> 小丑幽灵抛 -> 玉中杀快手'],
  ['2 Tap Lighthouse, 4 Tap Lighthouse, 6 Tap Lighthouse, Tradespike', '2タップ灯台～4タップ灯台～6タップ灯台～けん', '2Tap灯台 -> 4Tap灯台 -> 6Tap灯台 -> 持剑止'],
  ['Bird, Toss 2 Tap Swap 1.5 Kenflip Juggle 2 Inward Gunslinger 1.5 Kenflip Juggle Toss 2 Tap Swap Bird, Downspike', 'うぐいす～トス2タップスワップ1.5回転けんフリップジャグル2回転うら風車1.5回転けんフリップジャグルトス2タップスワップうぐいす～ダウンスパイク', '大鸟 -> 2Tap抛1.5回转 -> 反2圈神枪手 -> 1.5小丑Toss 2Tap大鸟 -> 天中杀'],
  ['1 Turn Lunar, 6 Tap Flip Lunar, 1 Turn In', '1回転月面～6タップ1回転月面～1回転さかおとし', '一回转月面 -> 6Tap一回转月面 -> 1回转收'],
  ['Tap 1.5 Swap Handlestall, Toss Tap 1.5 Swap Handlestall, Downspike', 'タップ1.5回転スワップ中皿極意～トスタップ1.5回スワップ中皿極意～ダウンスパイク', 'Tap 1.5中皿极意 -> 抛Tap1.5中皿极意 -> 天中杀'],
  ['Wing, Juggle 3 Kenflip Juggle Wing, 1 Turn Spike', 'ウィング～ジャグル3回転けんフリップジャグルウィング～回転けん', '大皿极易 -> 小丑3离转小丑大皿极易 -> 地球止'],
  ['Backward Inward Lunar, Tap 1.5 -> Tap Swap Kenflip Toss Tap 1.5 -> Tap Backward Inward Lunar, Flip Cushion Tap In', '前ふりバックワードうら月面～タップ1.5回転→タップスワップけんフリップトスタップ1.5回転→タップバックワードうら月面～1回転クッションタップイン', '梦逆月 -> Tap1.5回转Tap离转抛Tap1.5 -> 梦逆月 -> 一回转Cushion Tap收'],
  ['Spike, Whirlwind Around-the-Back Kengrip Catch Spike', 'スパイク～ワールウィンドアラウンドバックけんグリップキャッチスパイク', '止剑 -> 离转地球（反手绕腰抓取止剑）'],
  ['3 Kenflip 3 Kenflip 3 Toss Stuntplane Fasthand', '3回転けんフリップ3回転けんフリップ3回転トスすくいけんファストハンド', '3离转3离转3离转Toss玉中杀快手']
];

const KWC2026_LEVEL_14: Kwc2026Entry[] = [
  ['Big Tap 3 Tap Juggle Kenflip 3 Kenflip Spike', 'ビッグタップ3タップジャグルけんフリップ3回転けんフリップけん', '大Tap -> 3Tap小丑 -> 离转3圈Late离转止剑'],
  ['5 Jumping Stick, Inward 5 Jumping Stick', '5回転はねけん～うら5回転はねけん', '5跳剑 -> 反5跳剑'],
  ['Inward Lunar, Forward Tap 3 Flip Swap 3 Kenflip Inward 3 Toss Inward Lunar, Forward Tap 3 Flip Swap Spike', 'うら月面～フォワードタップ3回転フリップスワップ3回転けんフリップうら3回転トスうら月面～フォワードタップ3回転フリップスワップけん', '逆月 -> 前Tap3圈 -> 3离转 -> 反3离转逆月 -> 前Tap3圈持剑止'],
  ['Airplane, 8 Tap Swap Kenflip Downspike Fasthand', '飛行機～8タップスワップけんフリップダウンスパイクファストハンド', '飞机 -> 8Tap -> 抛天中杀快手'],
  ['3 Tap Lighthouse Insta 3 Lighthouse Flip Insta Toss Arm Bounce Inward 3 Flip Arm Lighthouse, Stuntplane Fasthand', '3タップ灯台インスタ3回転灯台とんぼ返りインスタトスアームバウンスうら3回転アーム灯台～すくいけんファストハンド', '3Tap灯台Insta三圈灯台Insta -> 抛手臂反Insta3圈手臂灯台 -> 玉中杀快手'],
  ['Airplane, 10 Tap Juggle Handlestall, 1 Turn Spike', '飛行機～10タップジャグル中皿極意～回転けん', '飞机 -> 10Tap -> 中皿极意 -> 地球止'],
  ['Big Wing, Toss Lighthouse Insta Swap 3 Kenflip Toss Lighthouse Insta Swap Small Wing, 1 Turn Spike', '大皿極意～トス灯台インスタスワップ3回転けんフリップトス灯台インスタスワップ小皿極意～回転けん', '大皿极易 -> 抛灯台Insta -> 3圈离转抛灯台Insta -> 小皿极易 -> 地球止'],
  ['Stilt, Typhoon 3 Stilt Flip, Typhoon Flip In', 'たけうま～タイフーン3回転たけうまとんぼ返り～タイフーン1回転さかおとし', '竹马 -> 转球3圈竹马 -> 转球一回转持球收'],
  ['2 Gunslinger Bird, 2 Gunslinger Bird over the Valley, 2 Gunslinger Handlestall, 2 Gunslinger Spike', '2回転風車うぐいす～2回転風車うぐいすの谷渡り～2回転風車中皿極意～2回転風車けん', '2神枪手大鸟 -> 2神枪手小鸟 -> 2神枪手中皿极意 -> 2神枪手止剑'],
  ['Stuntplane, 5 Stuntplane Flip Stuntplane Fasthand', 'すくいけん～5回転すくいけんフリップすくいけんファストハンド', '玉中杀 -> 5圈玉中杀快手']
];

const KWC2026_LEVEL_15: Kwc2026Entry[] = [
  ['4 Turn Inward Lunar, 4 Back Flip Inward Lunar, Inward 4 Flip In', '4回転うら月面～4回転バックフリップうら月面～うら4回転さかおとし', '4回转逆月面 -> 4回转梦月面 -> 逆转4回转持球收'],
  ['3 Kenflip - 3 Flip - 3 Flip Juggle 9 Tap Swap Spike', '3回転けんフリップ3フリップ3フリップジャグル9タップスワップけん', '3离转 -> 3离转3Late离转 -> 小丑9Tap持剑止'],
  ['1-2-3-4-5 Stuntplane Flip', 'すくいけんフリップ1-2-3-4-5', '玉中杀1-2-3-4-5'],
  ['Inward Lunar, Knee Bounce Inward 3 Flip Juggle Ghost Toss Knee Bounce Inward 3 Flip Inward Lunar, Tradespike', 'うら月面～リフティングうら3回転フリップジャグルゴーストトスリフティングうら3回転うら月面～けん', '逆月面 -> 膝撞3圈小丑幽灵抛膝撞3圈逆月 -> 持剑止'],
  ['6 Tap Swap Toss Lighthouse Insta 3 Lighthouse Flip Insta Swap Juggle 3 Kenflip - 3 Flip Juggle 3 Kenflip Stuntplane Fasthand', '6タップスワップトス灯台インスタ3回転灯台とんぼ返りインスタスワップジャグル3回転けんフリップ3回転フリップジャグル3回転けんフリップすくいけんファストハンド', '6Tap抛灯台Insta3圈灯台Insta -> 抛3离转3Late离转小丑抛3圈玉中杀快手'],
  ['Candle Around Stall, 1 Turn Spike', 'ろうそく返しふち一周～回転けん', '烛台转极易一周 -> 地球止'],
  ['1 Turn Lighthouse Insta 3 Flip 3 Tap Lighthouse Insta 3 Lighthouse Flip Insta 3 Flip 3 Tap Flip In', '1回転灯台インスタ3回転フリップ3タップ灯台インスタ3回転灯台とんぼ返りインスタ3回転フリップ3タップフリップイン', '一回转灯台Insta3圈 -> 3Tap灯台Insta灯台3圈Insta灯台3圈 -> 3Tap一回转持球收'],
  ['Bosch 2026', 'ボッシュ2026', 'Bosch 2026'],
  ['Arm Landing, Tama Toss Arm Handlestall, Spike', 'アーム着陸～玉トスアーム中皿極意～けん', '手臂着陆 -> 抛球手臂中皿极意 -> 止剑'],
  ['Stuntplane, 3 Stuntplane Flip Cushion Tap Swap 3 Kenflip Juggle 2 Tap Big Tap 3 Tap Juggle 3 Kenflip Juggle 3 Kenflip 3 Kenflip Cushion Tap Stuntplane Fasthand', 'すくいけん～3回転すくいけんクッションフリップタップスワップ3回転けんフリップジャグル2タップビッグタップ3タップジャグル3回転けんフリップジャグル3回転けんフリップ3回転けんフリップクッションタップすくいけんファストハンド', '玉中杀 -> 3圈Cushion Tap -> 3离转小丑2Tap -> 大Tap -> 2Tap -> 小丑离转3圈Cushion Tap -> 玉中杀快手']
];

export const KWC2026_TRICKS: TournamentTrick[] = [
  ...createLevelTricks(1, KWC2026_LEVEL_1),
  ...createLevelTricks(2, KWC2026_LEVEL_2),
  ...createLevelTricks(3, KWC2026_LEVEL_3),
  ...createLevelTricks(4, KWC2026_LEVEL_4),
  ...createLevelTricks(5, KWC2026_LEVEL_5),
  ...createLevelTricks(6, KWC2026_LEVEL_6),
  ...createLevelTricks(7, KWC2026_LEVEL_7),
  ...createLevelTricks(8, KWC2026_LEVEL_8),
  ...createLevelTricks(9, KWC2026_LEVEL_9),
  ...createLevelTricks(10, KWC2026_LEVEL_10),
  ...createLevelTricks(11, KWC2026_LEVEL_11),
  ...createLevelTricks(12, KWC2026_LEVEL_12),
  ...createLevelTricks(13, KWC2026_LEVEL_13),
  ...createLevelTricks(14, KWC2026_LEVEL_14),
  ...createLevelTricks(15, KWC2026_LEVEL_15)
];
